<template lang="html">
  <v-app class="large-screen__body white">
    <topbar v-if="activeTabbar === 'messages'" activeTab="messages" class='fixed-nav'></topbar>
    <div :class="{'fixed-top': activeTabbar === 'messages'}">
      <v-toolbar flat>
        <!-- left icons -->
        <div class="back-button-toolbar">
          <v-btn icon class="toolbar-button" @click="$router.go(-1)">
            <img src="~icons/backIcon/backIcon.png" alt="backIcon">
          </v-btn>
        </div>

        <v-spacer></v-spacer>
        <v-toolbar-title class="white--text">
          {{ task.task_name }}
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-menu bottom left style="z-index: 40;">
          <v-btn icon slot="activator" dark>
            <img src="~icons/moreIcon/moreIcon.png" alt="moreIcon">
          </v-btn>
          <v-list>
            <v-list-tile @click="copyToClipboard(task.task_ref)">
              <v-list-tile-title>Copy REF Link</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="isOrganizer" @click="$router.push({ name: 'TaskEdit', params: {id: task.task_id}})">
              <v-list-tile-title>Edit</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>

       <!-- tabs -->
      <v-tabs grow centered class="primary-tabs white--text">
        <v-tab :to="{ name: 'TaskDetails' }" class="white--text">
          Info
        </v-tab>
        <v-tab :to="{ name: 'TaskDetailsPeople' }" class="white--text">
          People
        </v-tab>
        <v-tab :to="{ name: 'TaskDetailsChat' }" class="white--text">
          Chat
        </v-tab>
      </v-tabs>
    </div>

    <router-view></router-view>

    <!-- task heading and details -->
    <div class="action-button">
      <div v-if="activeTabbar ==='overview'" class="">
        <v-btn-toggle>
          <v-btn icon @click="registerTask" v-if="allowRegister" :disabled="status !== '1'">
            Register
          </v-btn>
          <v-btn icon @click="completeTask" v-else :disabled="!completionOpen">
            Complete
            <template v-if="!completionOpen">
              [N/A]
            </template>
          </v-btn>
          <v-btn class="follow-button" title="follow this effort" @click="followTask" v-if="allowFollow">
            <v-icon>remove_red_eye</v-icon>
          </v-btn>
          <v-btn class="follow-button" :title="unfollowButtonTitle" @click="handleUnfollowClick" v-else>
            <v-icon>visibility_off</v-icon>
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>

    <v-dialog v-model="unfollowConfirmation" max-width="500px" content-class="wrap-dialog">
      <div>
        <v-card>
          <v-card-title>
            <h4>
              Are you sure you want to unregister from this effort?
            </h4>
          </v-card-title>
          <v-card-actions>
            <v-btn color="primary" flat @click.stop="unfollowConfirmation=false">Cancel</v-btn>
            <v-btn color="primary" flat @click.stop="unregisterTask">Unregister</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>


    <!-- completion questions -->
     <v-dialog
       v-model="dialog"
       persistent
       transition="dialog-bottom-transition"
     >
       <question :shwoLoader="fetchingQuestions" @close="close"></question>
     </v-dialog>
  </v-app>
</template>

<script>
import { get } from 'lodash';
import clipboard from '@/mixins/clipboard';

import Topbar from '@/components/Topbar';
import Question from '@/components/Question';

export default {
  mixins: [clipboard],
  components: { Topbar, Question },
  data() {
    return {
      fetchingQuestions: false,
      dialog: false,
      unfollowConfirmation: false,
    };
  },
  methods: {
    completeTask() {
      this.getCompletionItems();
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    getCompletionItems() {
      this.fetchingQuestions = true;
      this.$store.dispatch('completionQuestions/getCompletionItems', { task_id: this.taskId })
        .then(() => {
          this.fetchingQuestions = false;
        });
    },
    registerTask() {
      this.$store.dispatch('tasks/registerTask', this.taskId);
    },
    followTask() {
      this.$store.dispatch('tasks/followTask', this.taskId);
    },
    unfollowTask() {
      this.$store.dispatch('tasks/unfollowTask', this.taskId);
    },
    unregisterTask() {
      this.unfollowConfirmation = false;
      this.$store.dispatch('tasks/unregisterTask', this.taskId);
    },
    copyToClipboard(taskRef) {
      const routeName = this.$router.resolve({
        name: 'DirectCompletionQuestions',
        params: { ref: taskRef },
      });
      const origin = window.location.origin;
      this.clipboard(`${origin}/${routeName.href}`);
    },
    handleUnfollowClick() {
      if (this.allowRegister) {
        this.unfollowTask();
      } else {
        this.unfollowConfirmation = true;
      }
    },
  },
  computed: {
    unfollowButtonTitle() {
      if (this.allowRegister) {
        return 'Unfollow this effort';
      }

      return 'Unregister from this effort';
    },
    userTaskScope() { return this.$store.getters['tasks/userTaskScope']; },
    activeTabbar() {
      return this.$route.meta.query.activeTabbar || 'overview';
    },
    task() {
      return this.$store.getters['tasks/task'] || {};
    },
    taskId() {
      return this.task.task_id;
    },
    status() {
      return this.task.task_status;
    },
    organizers() {
      return this.$store.getters['tasks/organizers'];
    },
    taskOrganizer() {
      return get(this.organizers, '[0].username', '-');
    },
    isOrganizer() {
      return this.userTaskScope.includes('organizer');
    },
    allowFollow() {
      if (this.isOrganizer) return false;
      return !this.userTaskScope.includes('follower');
    },
    allowRegister() {
      if (this.isOrganizer) return false;
      return !this.userTaskScope.includes('registered');
    },
    completionOpen() {
      return this.task.completion_open === 1 && this.status === '1';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
#app {
    .fixed-top .toolbar__title {
      margin-left: 0px;
      margin-top: 10px;
      overflow: hidden;
      padding-left: 10px;
      padding-right: 10px;
      text-align: center;
      text-overflow: ellipsis;
      white-space: initial;
      white-space: nowrap;
      word-break: break-word;
    }

    .fixed-nav {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }

    // these are all for large screen adapt them for other screen sized
    @media only screen and (max-width: 599px) {
      .fixed-top {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 33;
      }
    }

    @media only screen and (min-width: 600px) and (max-width: 1600px) {
      .fixed-top {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 33;
      }
    }


    @media only screen and (min-width: 1600px) {
      .fixed-top {
        z-index: 20;
        position: fixed;
        left: 300px;
        width: calc(100vw - 300px);
      }
    }

    .back-button-toolbar {
      margin-bottom: auto;
      margin-top: 10px;
    }

    .btn-toggle {
      background: $primary !important;
      height: auto;
      margin-bottom:24px;
      border-radius:24px 24px 24px 24px;
      background-color: white;
      box-shadow: none;
      min-width: 150px;
      padding-left: 10px;

      .btn {
        width: auto;
        padding: 8px;
        height:100%;
        border: none;
        color: white !important;
      }

      .btn:first-child {
        border-top-left-radius: 23px;
        width:70%;
        border-bottom-left-radius: 23px;
        border-right: 1px solid #d64054;
        padding-right: 15px;
      }

      .btn:last-child {
        width: 30%;
        box-shadow: none;
        height: auto;
        border-top-right-radius: 23px;
        border-bottom-right-radius: 23px;
      }
    }

    @media only screen and (max-width: 800px) {
      .toolbar {
        margin-bottom: -2px;
      }
    }
}

.action-button {
  position: fixed;
  bottom: 5px;
  min-width: 100px;
  left: calc(50% - 90px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  margin-bottom: 20px;
}


@media only screen and (max-width:600px) {
  .action-button {
    margin-bottom: 50px;
  }
}

@media only screen and (min-width:1600px) {
  .action-button {
    left: calc(50vw + 100px);
  }
}

.follow-button {
  background: #d6405433 !important;
}

button:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// src/layouts/EffortDetailsLayout.vue